import {
  ListItemButton as MuiListItemButton,
  ListItemButtonProps as MuiListItemButtonProps,
} from '@mui/material';
import { toLinkProps } from '../utils/toLinkProps';

type Props = Pick<
  MuiListItemButtonProps,
  'onClick' | 'children' | 'className' | 'sx' | 'disabled'
> & {
  isActive?: boolean;
  testId?: string;
  to?: string;
};

const ListItemButton = ({
  isActive = false,
  className,
  children,
  onClick,
  sx,
  disabled,
  testId,
  to,
}: Props) => {
  return (
    <MuiListItemButton
      disableGutters
      selected={isActive}
      className={className}
      onClick={onClick}
      sx={sx}
      disabled={disabled}
      test-id={testId}
      {...toLinkProps(to)}
    >
      {children}
    </MuiListItemButton>
  );
};

export default ListItemButton;
